import { Currency } from '@/utils/currency'
import { Language } from '@/utils/language'

export const PAGE_SIZE = 20

export const ESHOP_TOKEN_COOKIE_NAME = 'lchr_eshop_token'

export const ESHOP_COOKIE_CONSENT_NAME = 'lchr_eshop_cookies'

export const eshopInputClasses = 'border-1 rounded-lg py-4'

export const manufacturers = ['Lach-Ner'] as const

export const defaultManufacturer = 'Lach-Ner' as const

export const layoutPortalId = 'eshoplayoutportal'

export const ccToString: Record<Currency, string> = {
    CZK: 'Kč',
    EUR: 'EUR',
    HUF: 'HUF',
}

export const k2CurrencyToCc: Record<string, Currency> = {
    Kč: 'CZK',
    EUR: 'EUR',
    HUF: 'HUF',
}

export const languageToLanguageId: Record<Language, number> = {
    cs: 5,
    en: 1,
    hu: 6,
}

export const languageIdToLanguageCode: Record<number, string> = {
    5: 'cz',
    1: 'gb',
    6: 'hu',
}

export const languageIdToLocale: Record<number, string> = {
    5: 'cs',
    1: 'en',
    6: 'hu',
}

export const languageCodeToLanguageName: Record<string, string> = {
    cz: 'eshop.documents.languages.czech',
    en: 'eshop.documents.languages.english',
    gb: 'eshop.documents.languages.english',
    hu: 'eshop.documents.languages.hungary',
}
